import angular from "angular";

import ValueToken from "../../parser-tokens/ValueToken";
import SearchParsingError from "../../errors/SearchParsingError";

const logSvc = new WeakMap();

class ValueTokenFactory {
    constructor($log) {
        if ($log != null) {
            logSvc.set(this, $log);
        }
        else {
            throw new Error("Missing log service dependency");
        }
    }

    toString() {
        return "ValueTokenFactory";
    }

    buildToken(tokenValue) {
        if (!angular.isString(tokenValue)) {
            logSvc.get(this).error("Value Token Maker: provided value is not a string");
            throw new SearchParsingError("Cannot make value token from non-string");
        }

        if (tokenValue.length === 0) {
            logSvc.get(this).error("Value Token Maker: provided value is the empty string");
            throw new SearchParsingError("Cannot make value token from empty string");
        }

        return new ValueToken(tokenValue);
    }
}

ValueTokenFactory.$inject = ["$log"];

export default ValueTokenFactory;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/token-factories/ValueTokenFactory.js
// module id = 7TY6
// module chunks = 1